import { cn } from "@/lib/utils";

/** `wide` for hero/progress bands, `reading` for long-form text. */
export const Container = ({ size = "wide", className, children, ...rest }) => (
  <div
    className={cn(
      "mx-auto w-full px-5 sm:px-8",
      size === "reading" ? "max-w-reading" : "max-w-shell",
      className
    )}
    {...rest}
  >
    {children}
  </div>
);
